import * as React from "react";

import {Col, NavDropdown, Row} from "react-bootstrap";
import {NavLink, useLocation, Outlet} from "react-router-dom";
import { Utils } from "../../common/utils";
import * as _ from "lodash";
import {InternalProvider, useInternalContext} from "@/contexts/internal";

interface MenuRoute {
    title: string
    route: string
}

interface MenuSubRoute extends MenuRoute{
    header: string
}

interface MenuOption extends MenuRoute{
    subRoutes: MenuSubRoute[]
}

const MENU_OPTIONS: MenuOption[] = [
  {
    title: "Schools",
    route: "/schools",
    subRoutes: [
      {
        title: "School Management",
        route: "/manage",
        header: "manage schools",
      },
      {
        title: "Features",
        route: "/features",
        header: "features",
      },
      {
        title: "Notifications",
        route: "/banners",
        header: "notifications",
      },
      {
        title: "Official Student List Upload",
        route: "/official-student-list-upload",
        header: "Official Student List Upload",
      },
    ],
  },
  {
    title: "Dashboards",
    route: "/dashboards",
    subRoutes: [
      {
        title: "Dashboard Registration",
        route: "/register",
        header: "dashboard registration",
      },
    ],
  },
  {
    title: "Ingestion",
    route: "/ingestion",
    subRoutes: [
      {
        title: "Postscript Terms",
        route: "/postscript/terms",
        header: "postscript term",
      },
      {
        title: "Categories",
        route: "/categories",
        header: "manage categories",
      },
      {
        title: "Courses",
        route: "/courses",
        header: "courses",
      },
      {
        title: "Question Categorizer",
        route: "/question-categorizer",
        header: "Question Categorizer",
      },
    ],
  },
];

function SuperAdmin() {
    const location = useLocation();
    const {renderActionButton} = useInternalContext();

    const renderMenuOptions = () => {
        const menuOptions: JSX.Element[] = [];
        let menuHeader = "Super";
        let first = true;
        _.forEach(MENU_OPTIONS, (option: MenuOption) => {
            if (first) {
                first = false;
            } else {
                menuOptions.push(<NavDropdown.Divider key={`${option.title}-divider`}/>);
            }

            menuOptions.push(<NavDropdown.Header key={option.title}>{option.title}</NavDropdown.Header>);

            option.subRoutes.map((subOption: MenuSubRoute) => {
                const pathStr = `${Utils.getLinkBase()}/internal${option.route}${subOption.route}`;

                if (pathStr === location.pathname) {
                    menuHeader = subOption.header;
                }

                menuOptions.push(
                    <NavDropdown.Item key={pathStr} as={NavLink} to={pathStr}>{subOption.title}</NavDropdown.Item>
                );
            });
        });

        return (
            <NavDropdown title={menuHeader} id="super-admin-menu">
                {menuOptions}
            </NavDropdown>
        );
    };

    return (
        <>
            <Row className="section-action-bar">
                <Col md={12} lg={6} className="title">
                    {renderMenuOptions()}
                </Col>
                {renderActionButton
                    ? <Col>
                        {renderActionButton}
                    </Col>
                    : null}
            </Row>
            <Outlet/>
        </>
    );
}

export default function SuperAdminLayout() {
    return (
        <InternalProvider>
            <SuperAdmin/>
        </InternalProvider>
    );
}